export default __webpack_public_path__ + "static/media/check-icon.a6f0e5c6.svg";